import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { getUserFieldValue } from '../../../../Util/Util';

const RatingInput = (props) => {
	const { t } = useTranslation();

	const {form_component, sub_question, rating_label, index, index2} = props;

	const userData = useSelector(state => state.userData);
	const fv = useSelector(state => state.fv);
	let userFieldValue = getUserFieldValue(form_component.fieldname, userData);

	const id = `q-${form_component.fieldname}-${index}-${index2}`;

	const handleChange = (e) => {
		// Trigger validation for all rating fields if ban_duplicate_rating is enabled
		if (form_component.ban_duplicate_rating && fv && form_component.rating?.sub_questions?.length) {
			// Use setTimeout to ensure the DOM is updated before validation
			setTimeout(() => {
				// Revalidate all rating fields to check for duplicates
				form_component.rating.sub_questions.forEach((_, subIndex) => {
					const fieldName = `${form_component.fieldname}[${subIndex}]`;
					fv.revalidateField(fieldName);
				});
			}, 0);
		}
	};

	return (
		<>
		<input
			type="radio"
			id={id}
			name={`${form_component.fieldname}[${index}]`}
			value={index2}
			checked={userFieldValue && userFieldValue[index] === index2}
			onChange={handleChange}
		/>
		<label htmlFor={id}>
			<div className="d-flex gap-3 opt">
				<div className="x-radio"></div>
				<div className="ans">
					<p className="mb-0 d-xl-none">
						{rating_label}
					</p>
					<div className="pic w-100 ">
					</div>
				</div>
			</div>
		</label>
		</>
	);
}

export default RatingInput;